import React, { useContext, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import { Zoom } from '@mui/material';
import Box from '@mui/material/Box';
import { Autocomplete } from '@mui/material';
import { museumApi } from '../../../services/MuseumServices';
import { curatorInitialValue, curatorValidation } from './CuratorModel';
import { usersActionServices } from '../../../services/UserServices';
import { SNACKBAR_OPEN } from '../../../reducers';
import { DispatchContext, StateContext } from '../../../store';
import { invitationServices } from '../../../services/AuthServices';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{ transitionDelay: '150ms' }} ref={ref} {...props} />;
});

export default function CreateCurators({ open, handleAction, curatorId, roleId }) {
  const dispatch = useContext(DispatchContext);
  const { role } = useContext(StateContext);
  const [initialValues, setInitialValues] = useState({ ...curatorInitialValue, role_id: 2 });
  const [museums, setMuseums] = useState([]);

  const isSuperAdmin = role?.id === 1;
  const roleOptions = [
    { id: 2, name: 'Curator' },
    { id: 10, name: 'Museum Chief' }
  ];

  useEffect(() => {
    if (open && curatorId) {
      usersActionServices('get', curatorId).then(res => {
        const museumArray = Object.values(res?.data?.museums || {}).map(museum => museum?.id);
        setInitialValues({
          ...res?.data,
          museum_ids: museumArray,
        });
      });
    }
  }, [open]);

  useEffect(() => {
    getMuseumList();
  }, []);

  const getMuseumList = () => {
    museumApi('get', null, { per_page: 100 }).then(response => {
      setMuseums(response?.data);
    })
  }

  const onSubmit = (values) => {
    const curatorValues = {
      ...values,
      museum_ids: [values?.museum_ids],
      phone: parseInt(values?.phone),
      cid: parseInt(values?.cid),
      role_ids: [values?.role_id || 2]
    }

    const curatorUpdatedData = {
      museum_ids: values?.museum_ids,
      first_name: values?.first_name,
      last_name: values?.last_name,
      email: values?.email,
      emp_id: values?.emp_id,
      phone: parseInt(values?.phone),
      cid: parseInt(values?.cid),
      profile: {
        agency: values?.profile?.agency,
      },
      role_ids: [values?.role_id || 2]
    }

    if (curatorId) {
      usersActionServices('put', curatorId, null, { ...curatorUpdatedData }).then(res => {
        dispatch({
          type: SNACKBAR_OPEN,
          payload: { isNotify: true, severity: 'success', message: 'Curator updated successfully' }
        });
        dispatch({
          type: 'STATE',
          payload: {
            change: true
          },
        });
        handleAction();
      }).catch(() => {})
    } else {
      invitationServices('post', { ...curatorValues }).then(res => {
        dispatch({
          type: SNACKBAR_OPEN,
          payload: { isNotify: true, severity: 'success', message: 'Curator invited successfully' }
        });
        handleAction();
      }).catch(() => {})
    }
  }

  const getSelectedMuseum = (museumId) => {
    return museums?.find(val => parseInt(val?.id) === parseInt(museumId)) || null;
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleAction}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={'sm'}
    >
      <DialogTitle color={'#616B88'} sx={{ fontSize: 30 }} className={'text-bold'}
        fontWeight={700}>{curatorId ? 'Update User' : 'Invite Users'}</DialogTitle>
      <Box className={'common-divider'} />
      <Formik initialValues={initialValues}
        onSubmit={onSubmit} validationSchema={curatorValidation}
        validateOnBlur={true} enableReinitialize
      >
        {({ isSubmitting, touched, errors, values, setFieldValue, ...formik }) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item sm={6}>
                  <Autocomplete
                    id="combo-box-demo"
                    options={museums}
                    value={getSelectedMuseum(values?.museum_ids)}
                    getOptionLabel={(option) => (option?.name)}
                    size={'small'}
                    className="dob mr-2 mt-3"
                    onChange={(e, value) => {
                      setFieldValue('museum_ids', value?.id || null);
                    }}
                    renderInput={(params) => <Field component={TextField} {...params}
                      placeholder="Choose museum"
                      label={
                        <div>
                          <span style={{ color: 'red' }}>*</span>
                          Select Museum
                        </div>
                      }
                      InputLabelProps={{
                        style: { color: '#929191', fontSize: 14 },
                        shrink: true
                      }}
                      name="museum_ids" />}
                  />
                </Grid>
                {isSuperAdmin && (
                  <Grid item sm={6}>
                    <FormControl fullWidth size="small" className="mt-3">
                      <InputLabel>
                        <span style={{ color: 'red' }}>*</span>Select Role
                      </InputLabel>
                      <Field
                        id="outlined-basic"
                        component={Select}
                        name="role_id"
                        value={values?.role_id || 2}
                        onChange={(e) => setFieldValue('role_id', e.target.value)}
                        label="Select Role"
                        variant="outlined"
                      >
                        {roleOptions.map((role) => (
                          <MenuItem key={role.id} value={role.id}>
                            {role.name}
                          </MenuItem>
                        ))}
                      </Field>
                    </FormControl>
                  </Grid>
                )}
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                    label={
                      <div>
                        <span style={{ color: 'red' }}>*</span>
                        Name
                      </div>
                    }
                    name="first_name"
                    InputLabelProps={{
                      style: { fontSize: 14, color: '#929191' }
                    }} />
                </Grid>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Surname'}
                    name="last_name"
                    InputLabelProps={{
                      style: { fontSize: 14, color: '#929191' }
                    }} />
                </Grid>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'CID/Passport'}
                    name="cid"
                    inputProps={{ maxLength: 11 }}
                    InputLabelProps={{
                      style: { fontSize: 14, color: '#929191' }
                    }} />
                </Grid>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                    label={
                      <div>
                        <span style={{ color: 'red' }}>*</span>
                        Contact No.
                      </div>
                    }
                    name="phone"
                    InputLabelProps={{
                      style: { fontSize: 14, color: '#929191' }
                    }} />
                </Grid>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Employee ID'}
                    name="emp_id"
                    InputLabelProps={{
                      style: { fontSize: 14, color: '#929191' }
                    }} />
                </Grid>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Agency'}
                    name="profile.agency"
                    InputLabelProps={{
                      style: { fontSize: 14, color: '#929191' }
                    }} />
                </Grid>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                    label={
                      <div>
                        <span style={{ color: 'red' }}>*</span>
                        Email ID
                      </div>
                    }
                    name="email" type={'email'} disabled={!!curatorId}
                    InputLabelProps={{
                      style: { fontSize: 14, color: '#929191' }
                    }} />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleAction} variant={'outlined'} color={'error'} className={'text-capitalize'}
                sx={{ width: 40, height: 30 }}>cancel</Button>
              <Button variant={'contained'} type={'submit'} className={'text-capitalize'}
                sx={{ width: 40, height: 30 }}>{curatorId ? 'Update' : 'Invite'}</Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};